/* TODO: t() */
/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { Component } from 'react';
import { View, ScrollView, StyleSheet } from 'react-native';

import { Button, Text, Card } from '../uiold';
import { themeColors } from '../uiold/Constants';
import TextInput from '../uiold/TextInput';
import { formatDateFull } from '../../support/DateTime';
import connectData, { ConnectedProps } from '../../support/connectData';

import {
  FieldValue,
  PendingFieldChange,
  VendorSummaryWithMarketsAndFields,
} from '../../types/shared/Vendor';
import {
  formatChoiceWithCharge,
  parseChargeFromValue,
} from '../../support/shared/calculatePrice';
import LoadingIndicator from '../uiold/LoadingIndicator';
import Imm from '../../support/ImmutableHelpers';
import { CurrencyProvider } from '../CurrencyContext';
import pushOrUpdateObjectByKey from '../../support/helpers/pushOrUpdateByKey';
import { showError, showSuccess } from '../App/AppAlert';
import { postJSON } from '../../support/Fetch';
import { VendorAccount } from '../../types/shared/VendorAccount';
import { showDialog } from '../App/AppDialog';
import { FileDesc } from '../../types/shared/FileDesc';
import Preview from '../Preview';
import { MarketsView } from '../FormFields/MarketsView';
import { MultichoiceElementDefinitionRuntype } from '../../runtypes/SignupFormDefinitionRuntype';

type Props = {
  vendorAccount: VendorAccount;
  toggleMyInfo: (shown: boolean) => void;
};

type State = {
  editingVendor: VendorSummaryWithMarketsAndFields | null;
  pendingFieldChanges: Array<PendingFieldChange>;
  isSubmitting: boolean;
  previewAttachment: FileDesc | null | undefined;
  requestNote: string;
  validationErrors: Map<string, string | null | undefined>;
};

class MyInfoPage extends Component<FullProps> {
  state: State = {
    editingVendor: null,
    pendingFieldChanges: [],
    isSubmitting: false,
    previewAttachment: null,
    requestNote: '',
    validationErrors: new Map(),
  };

  render() {
    let { account, vendor, formDef, vendorAccount } = this.props;
    let { editingVendor, isSubmitting, previewAttachment } = this.state;

    if (isSubmitting || !account || !vendor || !formDef || !vendorAccount) {
      return <LoadingIndicator />;
    }

    return (
      <ScrollView>
        <CurrencyProvider
          value={{
            currency: (account.settings && account.settings.currency) || 'USD',
          }}
        >
          <View style={styles.root}>
            {editingVendor
              ? this._renderEditProfileCard()
              : this._renderProfileCard()}
            {previewAttachment ? (
              <Preview
                file={previewAttachment}
                disablePageScroll={true}
                onClose={this._closePreview}
              />
            ) : null}
          </View>
        </CurrencyProvider>
      </ScrollView>
    );
  }

  _renderProfileCard = () => {
    let { vendor, markets, formDef, account } = this.props;
    if (!vendor || !markets || !formDef || !account) {
      return;
    }

    let { createdAt } = vendor;
    let currency = account.settings?.currency ?? 'USD';
    let items = [];
    let filteredFields = formDef.fields.toArray();
    // TODO: Share logic between VendorDetails and this

    for (let fieldDef of filteredFields) {
      let field = vendor.fields.find((field) => field.id === fieldDef.id);
      let fieldChangePending = vendor.pendingFieldChanges?.find(
        (field) => field.id === fieldDef.id,
      );
      let value = field == null ? null : field.value;
      if (MultichoiceElementDefinitionRuntype.guard(field)) {
        let optionsWithCharge = parseChargeFromValue(field.options);

        value = optionsWithCharge.map(({ name, charge, operator = '+' }) => {
          return formatChoiceWithCharge(name, charge, currency, operator);
        });
      }
      let element;
      if (fieldDef.type === 'MarketSelectorElement') {
        element = (
          <MarketsView
            fieldValue={field ?? undefined}
            markets={markets?.getList() ?? []}
          />
        );
      } else {
        element = fieldDef.renderReadOnlyView({
          value,
          isAdmin: false,
          onFileClick: this._onFileClick,
          definition: fieldDef.definition,
          fields: vendor.fields,
        } as any);
      }

      if (element != null) {
        let { definition, id } = fieldDef;
        let name = typeof definition.name === 'string' ? definition.name : '';
        items.push(
          <View
            key={`view-${id}`}
            style={[styles.profileColumn, { maxWidth: '100%' }]}
          >
            <Text type="label" style={styles.headerText}>
              {name} {fieldChangePending ? '(Change Pending)' : ''}
            </Text>
            {typeof element === 'string' ? (
              <Text style={styles.elementText}>{element}</Text>
            ) : (
              element
            )}
          </View>,
        );
      }
    }

    const doPendingChangesExist =
      this.props.vendor?.pendingFieldChanges &&
      this.props.vendor?.pendingFieldChanges?.length > 0;

    return (
      <Card isVendor style={styles.card}>
        {doPendingChangesExist && (
          <View style={{ backgroundColor: '#FBD38D', padding: '10px' }}>
            <Text style={{ textAlign: 'center' }}>
              {t(
                'Submitting a new change request will overwrite any pending change request that has not yet been reviewed.',
              )}
            </Text>
          </View>
        )}
        <Card.Header style={{ marginHorizontal: 30 }} showSeparator={false}>
          <Text style={styles.profileHeaderText}>My Profile</Text>
          <Button onPress={this._onEditClick} title="Request Changes" />
        </Card.Header>
        <View style={styles.profileCard}>
          {items}
          <View style={styles.profileColumn}>
            <Text type="label" style={styles.headerText}>
              Sign Up Date
            </Text>
            <Text type="label">{formatDateFull(createdAt, false, false)}</Text>
          </View>
        </View>
      </Card>
    );
  };

  // TODO: Refactor to use ProfileCard component
  _renderEditProfileCard = () => {
    let { addons, formDef, markets, vendor: vendorNullable } = this.props;
    let { validationErrors } = this.state;
    const visibleMarkets = markets?.filter((market) => market.hidden === false);
    let formData = this.state.editingVendor;
    if (!formData || !vendorNullable || !formDef) {
      return;
    }
    let vendor = vendorNullable;
    let items: Array<React.ReactElement> = [];
    let filteredFields = formDef.fields;

    filteredFields.forEach((fieldDef) => {
      let { id, definition } = fieldDef;
      let isHidden =
        typeof definition.hidden === 'boolean' ? definition.hidden : false;
      if (isHidden || !formData) {
        return null;
      }
      let fieldChangePending = vendor.pendingFieldChanges?.find(
        (field) => field.id === fieldDef.id,
      );
      let field = formData.fields.getByID(id);
      let value = field == null ? null : field.value;
      formDef;

      let element = fieldDef.renderEditView({
        isVendor: true,
        value: value ?? null,
        onChange: this._onFieldChange,
        onValidityChange: this._onFieldValidityChange,
        markets: visibleMarkets,
        vendor,
        addons,
        // Used in AddonElement.tsx -> renderEditView()
        fields: formData.fields,
        // TODO: I don't think formData is being used
        formData:
          fieldDef.type === 'AddonElement'
            ? formData.fields.getList()
            : undefined,
      } as any);

      if (element != null) {
        let { definition, id } = fieldDef;
        let name = typeof definition.name === 'string' ? definition.name : '';
        let validationError = validationErrors.get(id);
        items.push(
          <View key={`view-${id}`} style={styles.profileColumn}>
            <Text type="label" style={styles.headerText}>
              {name} {fieldChangePending ? '(Change Pending)' : ''}
            </Text>
            {typeof element === 'string' ? <Text>{element}</Text> : element}
            {this._renderFieldError(validationError)}
          </View>,
        );
      }
    });

    return (
      <Card isVendor style={styles.card}>
        <Card.Header
          style={
            {
              margin: 0,
              paddingHorizontal: 30,
              paddingVertical: 10,
              backgroundColor: 'white',
              position: 'sticky',
              top: 0,
              zIndex: 1,
            } as any
          }
          showSeparator={false}
        >
          <Text style={styles.profileHeaderText}>Request Changes</Text>
          <View style={styles.btnToolbar}>
            <Button onPress={this._onCancel} title="Cancel" />
            <Button onPress={this._onSubmit} title="Submit" isPrimary />
          </View>
        </Card.Header>
        <View style={styles.profileCard}>
          {items}
          <View style={styles.profileColumn}>
            <Text type="label" style={styles.headerText}>
              Change request notes
            </Text>
            <TextInput
              type="text"
              multiline={true}
              value={this.state.requestNote}
              onChangeText={(value) => {
                this.setState({
                  requestNote: value,
                });
              }}
            />
          </View>
        </View>
      </Card>
    );
  };

  _onFieldValidityChange = (
    fieldID: string,
    validationError: string | null | undefined,
  ) => {
    let { validationErrors } = this.state;
    let oldValue = validationErrors.get(fieldID);
    let newValue = validationError;
    if (oldValue !== newValue) {
      this.setState({
        validationErrors: new Map(validationErrors).set(fieldID, newValue),
      });
    }
  };

  _renderFieldError = (validationError: any) => {
    if (!validationError) {
      return;
    }
    return <Text style={styles.errorText}>{validationError}</Text>;
  };

  _renderDates = (marketDates: Array<string>) => {
    return (
      <View style={styles.flexRow}>
        {marketDates.map((marketDate, id) => {
          return (
            <View key={id} style={styles.marketColumn}>
              <Text type="label">
                {formatDateFull(marketDate, true, false)}
              </Text>
            </View>
          );
        })}
      </View>
    );
  };

  _onFieldChange = (fieldID: string, newValue: FieldValue) => {
    let vendor = this.props.vendor;
    let formData = this.state.editingVendor;
    let pendingFieldChanges = this.state.pendingFieldChanges;
    let { formDef } = this.props;
    if (!formData || !formDef || !vendor) {
      return;
    }
    let fields = formData.fields;
    let fieldDef = formDef.fields.getByID(fieldID);
    let oldValue = vendor.fields.find((field) => field.id === fieldID)?.value;

    if (!fieldDef) {
      return;
    }
    let { definition } = fieldDef;
    let name = typeof definition.name === 'string' ? definition.name : '';
    let newField = {
      id: fieldID,
      name,
      value: newValue,
    };
    let updatedField = {
      id: fieldID,
      name,
      oldValue,
      newValue,
    };
    let newFields = fields.hasID(fieldID)
      ? fields.setByID(fieldID, newField)
      : fields.push(newField);
    let newFormData = Imm.setProperty(formData, 'fields', newFields);
    let updatedFields = pushOrUpdateObjectByKey({
      arr: pendingFieldChanges,
      obj: updatedField,
      key: 'id',
    });
    this.setState({
      editingVendor: newFormData,
      pendingFieldChanges: updatedFields,
    });
  };

  _onEditClick = () => {
    this.setState({
      editingVendor: this.props.vendor,
    });
  };

  _onCancel = () => {
    this.setState({ editingVendor: null, pendingFieldChanges: [] });
  };

  _onSubmit = () => {
    let { fetchAll } = this.props;
    let { pendingFieldChanges, validationErrors } = this.state;
    let newPendingFieldChanges = pendingFieldChanges.filter(
      (item) => JSON.stringify(item.newValue) !== JSON.stringify(item.oldValue),
    );
    if (!newPendingFieldChanges || newPendingFieldChanges.length === 0) {
      showError('No changes detected');
      return;
    }
    const validationErrorValue = Array.from(validationErrors.values()).find(
      (value) => value != null,
    );
    if (validationErrorValue) {
      showError(
        t('Validation error: {error}', { error: validationErrorValue }),
      );
      return;
    }
    const doPendingChangesExist =
      this.props.vendor?.pendingFieldChanges &&
      this.props.vendor?.pendingFieldChanges?.length > 0;
    showDialog(
      `${doPendingChangesExist ? 'Overwrite' : 'Submit'} Change Requests?`,
      `${
        doPendingChangesExist
          ? 'You will overwrite your existing pending change requests. '
          : ''
      }Press OK to submit change requests. You'll receive an email when the changes have been reviewed.`,
      ['Cancel', 'OK'],
      (value) => {
        if (value === 'Cancel') {
          return;
        }
        postJSON('/api/change-requests', {
          changes: newPendingFieldChanges,
          requestNote: this.state.requestNote,
        });
        showSuccess(
          "Change requests submitted for review. You'll receive an email when the changes have been reviewed.",
        );
        // Not sure why, but it seems we need to defer the re-fetch till after the state has updated.
        this.setState({ editingVendor: null, pendingFieldChanges: [] }, () => {
          fetchAll();
        });
      },
    );
  };

  _onFileClick = (file: FileDesc, event: Event) => {
    event.preventDefault();
    this.setState({ previewAttachment: file });
  };

  _closePreview = () => {
    this.setState({ previewAttachment: null });
  };
}

let styles = StyleSheet.create({
  root: {
    width: '100%',
    height: '100%',
    paddingHorizontal: 36,
  },
  errorText: {
    marginTop: 10,
    color: themeColors.red,
    fontSize: 16,
  },
  btnToolbar: {
    flexDirection: 'row',
  },
  card: {
    marginBottom: 20,
  },
  flexRow: {
    flexDirection: 'row',
    flexWrap: 'wrap',
  },
  profileColumn: {
    marginVertical: 10,
    marginHorizontal: 30,
  },
  profileCard: {
    flexDirection: 'column',
    flexWrap: 'wrap',
  },
  marketColumn: {
    width: 180,
    marginVertical: 10,
    marginHorizontal: 10,
  },
  headerText: {
    marginTop: 10,
    marginBottom: 5,
    fontSize: 16,
    fontWeight: '500',
    color: themeColors.black,
  },
  profileHeaderText: {
    fontSize: 32,
    fontWeight: '500',
  },
  elementText: {
    color: themeColors.grey,
    fontSize: 18,
    fontWeight: '500',
  },
});

const connector = connectData<Props>()(() => ({
  vendor: { dataStoreKey: 'vendorInfo' },
  markets: { dataStoreKey: 'markets' },
  addons: { dataStoreKey: 'addons' },
  account: { dataStoreKey: 'marketPagesAccount' },
  formDef: {
    dataStoreKey: 'forms/:id',
    params: ['signup'],
  },
}));
type FullProps = ConnectedProps<typeof connector>;
export default connector(MyInfoPage);
